export const VISION_URL_REGISTRATION_RETRY_DELAYS_MS = [250, 1000] as const
